
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 58 76"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M48.002 16.873l-1.854 51a.682.682 0 01-.654.627H12.506c-.326 0-.642-.305-.654-.627l-1.854-51a3.5 3.5 0 00-6.996.254l1.855 51c.148 4.086 3.555 7.373 7.649 7.373h32.988c4.1 0 7.5-3.28 7.65-7.373l1.854-51a3.5 3.5 0 00-6.996-.254z"}}),_c('path',{attrs:{"d":"M26.5 27v34a2.5 2.5 0 005 0V27a2.5 2.5 0 00-5 0zm-11.499.073l1 34a2.5 2.5 0 004.998-.147l-1-34a2.5 2.5 0 00-4.998.147zm23-.146l-1 34a2.5 2.5 0 004.998.147l1-34A2.5 2.5 0 0038 26.927zM4 18h50a3.5 3.5 0 100-7H4a3.5 3.5 0 100 7z"}}),_c('path',{attrs:{"d":"M22.395 12.849l1.03-4.117c.147-.588.97-1.232 1.571-1.232h8.008c.601 0 1.424.643 1.571 1.232l1.03 4.117 6.79-1.698-1.029-4.117C40.44 3.33 36.818.5 33.004.5h-8.008c-3.814 0-7.437 2.832-8.362 6.534l-1.03 4.117 6.792 1.698z"}})])
          )
        }
      }
    